import { forwardRef } from 'react';
import { Search } from 'lucide-react';
import { ADMIN_COLORS } from '@/features/admin/utils/adminAnimations';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  function SearchInput({ value, onChange, placeholder, className }, ref) {
    return (
      <div className={`flex-1 relative ${className ?? ''}`}>
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-500" />
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          style={{
            backgroundColor: ADMIN_COLORS.surface,
            border: `1px solid ${ADMIN_COLORS.border}`,
            boxShadow: ADMIN_COLORS.shadow,
          }}
        />
      </div>
    );
  }
);
